import * as tslib_1 from "tslib";
import { themr } from '@nextiva/analytics-lib';
import { SvgIcon } from '@nextiva/next-ui';
import React from 'react';
import checkmarkIcon from './checkmark.svg';
import Styles from "./CheckmarkSvg.css";

var Checkmark = function Checkmark(_a) {
  var theme = _a.theme,
      otherProps = tslib_1.__rest(_a, ["theme"]);

  return React.createElement(SvgIcon, tslib_1.__assign({
    src: checkmarkIcon,
    className: theme.checkMark
  }, otherProps));
};

export default themr(Checkmark, Styles);